import { Route } from 'vue-router';

import LoginDashboard from '@/app/features/Customer/features/Login/LoginDashboard.vue';
import RegisterDashboard from '@/app/features/Customer/features/Register/RegisterDashboard.vue';

import { ENavigationGuardTypes, ECheckoutStep } from '@/helpers/enums';

export default [
  {
    path: '/cadastro',
    name: 'registerToDashboard',
    component: RegisterDashboard,
    meta: {
      checkoutStep: ECheckoutStep.none,
      navigationGuardType: ENavigationGuardTypes.authenticationDashboard,
    },
  },
  {
    path: '/login',
    name: 'loginToDashboard',
    component: LoginDashboard,
    meta: {
      checkoutStep: ECheckoutStep.none,
      navigationGuardType: ENavigationGuardTypes.authenticationDashboard,
    },
    props: (route: Route) => ({
      showRegister: !route.query['goBackRoute'],
    }),
  },
  {
    path: '/loginAs',
    name: 'loginAs',
    component: LoginDashboard,
    meta: {
      checkoutStep: ECheckoutStep.none,
      navigationGuardType: ENavigationGuardTypes.authenticationDashboard,
    },
  },
];
